var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowDownwardLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37063_16859)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43323 3.63327L8.43323 12.2666L7.69989 12.2666L7.6999 3.63327L8.43323 3.63327Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60727 12.4106C8.31056 12.7624 7.79518 12.7135 7.50741 12.4258C7.50532 12.4237 7.50326 12.4216 7.50123 12.4194L4.13456 8.8861L4.66547 8.38023L8.0278 11.909C8.0388 11.9193 8.0501 11.9233 8.05791 11.9245C8.06156 11.9203 8.0653 11.9162 8.06914 11.9123L11.4691 8.37893L11.9976 8.88741L8.60727 12.4106Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37063_16859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.86667,
    height: 9.03333,
    fill: "white",
    transform: "translate(12 12.6665) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownwardLight);
export default __webpack_public_path__ + "static/media/icon_arrow_downward_light.ddd41bf8.svg";
export { ForwardRef as ReactComponent };